import React, { useState, useEffect } from 'react';
import DashboardCard from './DashboardCard';
import DashboardHeader from './DashboardHeader';
import HeaderLoading from '../../components/Header/HeaderLoading';

import chartProcessingTime from './ChartProcessingTime';
import { Col, Row } from 'reactstrap';

import dashboardService from '../../services/dashboardService';
import utility from '../../services/utility';

import DataTable from '../../components/Table/DataTable';
import { Chart } from "chart.js";
import { Line } from "react-chartjs-2";

import {
    chartOptions,
    parseOptions
} from "../../variables/charts";


const Dashboard = ({ onSetHeader }) => {
    const [data, setData] = useState(null);

    const NO_INFO_TO_DISPLAY = "No information to display";

    if (Chart) {
        parseOptions(Chart, chartOptions());
    }

    useEffect(() => {
        onSetHeader(<HeaderLoading text="Loading your dashboard ..."/>);
        dashboardService.get()
            .then(response => {
                setData(response);
                onSetHeader(<DashboardHeader data={response}></DashboardHeader>);
            }
        );
    }, [onSetHeader]);

    let processingTime = (processingTime) => {
        let cardContent = [];
        if (processingTime && processingTime.length > 0) {
            var todayProcessingTime = processingTime.filter(x => utility.isToday(x.key));
            if (todayProcessingTime.length > 0) {
                cardContent.push(<h3 key="subtitle-processing-time"
                    className="text-white">{`Today's average processing time is ${utility.formatMillisecondReadbleTime(todayProcessingTime[0].value)}`}</h3>);
            };
            cardContent.push(
                <div key="chart-processing" className="chart">
                    <Line
                        data={chartProcessingTime.data(processingTime)}
                        options={chartProcessingTime.options}
                    />
                </div>);
        }
        return <DashboardCard
            cardClasses={["bg-gradient-alternate"]}
            title="Average file processing time"
            titleClasses={["text-white"]}
            subTitle={cardContent.length === 0 && NO_INFO_TO_DISPLAY}
            subTitleClass={"h3 text-white"}>
            {cardContent}
        </DashboardCard>;;
    }

    let showFileCount = (showFileCount) => {
        let cardContent = [];
        if (showFileCount && showFileCount.length > 0) {
            const options = {
                column: {
                    "key": { classes: ["text-uppercase"], header: " Show " },
                    "value": {
                        classes: ["text-center"],
                        header: " File Count",
                        transform: (value) => <strong>{value}</strong>
                    }
                }
            };
            cardContent.push(<DataTable
                key="table-file-count"
                classes={["table-sm", "table-striped", "align-items-center", "table"]}
                columns={["key", "value"]}
                options={options}
                data={showFileCount} />);
        }
        return <DashboardCard
            title="In the past 7 days"
            subTitle={cardContent.length === 0 ? NO_INFO_TO_DISPLAY : "Files processed per show"}
            subTitleClass={"h3"}
            iconClass="fas fa-award"
            iconBackground="bg-gradient-warning"
            titleClasses={["text-muted align-items-center"]}
        >
            {cardContent}
        </DashboardCard>;;
    }

    return (data == null ||
        <Row className="dashboard-cards">
            <Col lg="12" xl="7" className="mb-2">
                {processingTime(data && data.processingTime)}
            </Col>
            <Col lg="12" xl="5" className="mb-2">
                {showFileCount(data && data.showFileCount)}
            </Col>
        </Row>
    );
}

export default Dashboard;